/**
 * useRequiredTeamId
 * 
 * Returns the active team ID or throws an error if not available.
 * Use this instead of fallback patterns to ensure mutations fail fast
 * when team context is missing.
 * 
 * @throws Error if no active team ID is available
 * @returns Active team ID (guaranteed to be non-null)
 */

import { useActiveTeamId } from '@/contexts/TeamContext';

export function useRequiredTeamId(): string {
  const teamId = useActiveTeamId();
  
  if (!teamId) {
    throw new Error('Active teamId is required but was not found. User must be authenticated and have an active team.');
  }
  
  return teamId;
}
